module.exports = __webpack_public_path__ + "static/img/minicons4.3ae05049.png";